export default () => ({
  namespaced: true,
  state     : {
    user_status: [
      {
        status  : 'status_confirmed',
        text    : 'Подтвержден',
        bg_color: 'section-label--green',
        id      : '114',
        active  : true,
      },
      {
        status  : 'status_off',
        text    : 'Отключен',
        bg_color: 'section-label--red',
        id      : '116',
        active  : false,
      },
      {
        status  : 'status_processing',
        text    : 'Обрабатывается',
        bg_color: 'section-label--blue',
        id      : '115',
        active  : false,
      },
      {
        status  : 'status_declined',
        text    : 'Отклонён',
        bg_color: 'section-label--black',
        id      : '117',
        active  : false,
      },
    ],
  },
  getters: {
    user_status      : ({user_status}) => user_status,
    status_confirmed : ({user_status}) => user_status.find( (user_stat) => user_stat.status === 'status_confirmed'),
    status_off       : ({user_status}) => user_status.find( (user_stat) => user_stat.status === 'status_off'),
    status_processing: ({user_status}) => user_status.find( (user_stat) => user_stat.status === 'status_processing'),
    status_declined  : ({user_status}) => user_status.find( (user_stat) => user_stat.status === 'status_declined'),
    status_active    : ({user_status}) => user_status.find( (user_stat) => user_stat.active),
  },
  mutations: {
    SET_STATUS(state, index) {
      state.user_status.forEach((x)=> x.active = false);
      state.user_status[index].active = true;
    },
    SET_STATUS_BY_ID(state, id) {
      state.user_status.map((x) => {
        x.active = false;

        if (parseInt(x.id) === parseInt(id)) {
          x.active = true;
        }

        return x;
      });
    },
  },
  actions: {
    SET_CURRENT_STATUS({commit, rootState}) {
      let SET_CURRENT_STATUS = rootState.profile.other_user.other_user.status_id;

      if (isNaN(parseInt(SET_CURRENT_STATUS)) || parseInt(SET_CURRENT_STATUS) === 0) {
        SET_CURRENT_STATUS = 114;
      }

      commit('SET_STATUS_BY_ID', SET_CURRENT_STATUS);
    },
  },
});
